import api from '../baseApi.js'
import { sortClasses, unwrap } from '../helpers.js'

export const classesApi = {
  getAll: () => api.get('/classes').then(unwrap).then(sortClasses),
  getOne: (id) => api.get(`/classes/${id}`).then(unwrap),
  create: (data) => api.post('/classes/create', data).then(unwrap),
  update: (id, data) => api.put(`/classes/${id}`, data).then(unwrap),
  remove: (id) => api.delete(`/classes/${id}`).then(unwrap),
  assignClassTeacher: (classId, data) =>
    api.put(`/classes/${classId}/class-teacher`, data).then(unwrap),
  assignTempClassTeacher: (classId, data) =>
    api.put(`/classes/${classId}/temp-class-teacher`, data).then(unwrap),
  removeTempClassTeacher: (classId) =>
    api.delete(`/classes/${classId}/temp-class-teacher`).then(unwrap),
  getSubjectTeachers: (classId) =>
    api.get(`/classes/${classId}/subject-teachers`).then(unwrap),
  promoteStudents: (classId, data) =>
    api.post(`/classes/${classId}/promote-students`, data).then(unwrap),
}
